import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import Button from "pages/_components/Button";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";
import Hint from "pages/_components/hints/Hint";

import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import {
    getMasspaymentsApiReceiptHint,
    isMasspaymentsCmfApiEnabled,
    MULTIPLE_TRANSFER_VOUCHER_COELSA_ID_LABEL_I18N_KEY,
} from "util/multipleTransfersCmf";

import {
    actions as actionsTransactionLines,
    selectors as selectorsTransactionLines,
} from "reducers/form/transactionLines";
import { actions as multipleTransferActions } from "reducers/multiple-transfers";

import MultipleTransferModal from "./MultipleTransferModal";

const FORM_ID = "multiple.transfers";

function MultipleTransferTicketData({ dispatch, isDesktop, data, batch, itemsDetail, isBackoffice, componentClass }) {
    const { idFile, idUser, amount, idTransactionStatus } = batch;
    const cmfReceiptHint = getMasspaymentsApiReceiptHint();
    const cmfApi = isMasspaymentsCmfApiEnabled();

    useEffect(() => {
        if (idFile && itemsDetail?.length <= 0 && !isBackoffice) {
            dispatch(multipleTransferActions.getFileContentsRequest(idFile, false, idUser));
        }
        return () => {
            dispatch(actionsTransactionLines.clearTransactionLines());
        };
        // eslint-disable-next-line
    }, [dispatch]);

    return (
        <>
            <div className={`transfer-multiple__ticket ${componentClass}`}>
                {Object.entries(data).map(([key, item]) => {
                    if (key === "reference") {
                        return (
                            <div className="transfer-data data-wrapper-flex" key={key}>
                                <span className="data-label no-wrap">
                                    {i18nUtils.get(`${FORM_ID}.summary.${key}.label`)}
                                </span>{" "}
                                <span
                                    className="data-desc text-right m-0"
                                    style={{
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word",
                                        maxWidth: "100%",
                                        flex: "1",
                                        textAlign: "right",
                                    }}>
                                    {item.value}
                                </span>
                            </div>
                        );
                    }
                    const summaryLabelKey =
                        cmfApi && key === "voucherNumber"
                            ? MULTIPLE_TRANSFER_VOUCHER_COELSA_ID_LABEL_I18N_KEY
                            : `${FORM_ID}.summary.${key}.label`;
                    return (
                        <Heading.DataGroup
                            key={key}
                            containerClassName="transfer-data data-wrapper-flex"
                            label={summaryLabelKey}
                            labelClassName="no-wrap"
                            data={(() => {
                                if (item.format.includes("date")) {
                                    return (
                                        <FormattedDate
                                            date={item.value}
                                            dateFormat={
                                                item.format === "datetime" ? "dd/MM/yyyy hh:mm:ss" : "dd/MM/yyyy"
                                            }
                                            showTime={item.format === "datetime"}
                                        />
                                    );
                                }
                                if (item.format.includes("amount")) {
                                    return (
                                        <FormattedAmount
                                            {...amount}
                                            notBold
                                            className={`${isDesktop ? "f-size-4" : "f-size-65"}`}
                                        />
                                    );
                                }
                                return item.value;
                            })()}
                            dataClassName="data-desc text-right"
                        />
                    );
                })}
                {cmfReceiptHint && idTransactionStatus === "PROCESSING" ? (
                    <Hint
                        classNameMessage=""
                        classNameGroup="justify-content-center d-flex my-3"
                        classNameImage="my-0 ml-2 justify-content-center align-self-center"
                        classNameHintP="aling-items-center my-2"
                        alwaysShowMessage
                        nodeMessage={<p className="hint-text">{cmfReceiptHint}</p>}
                    />
                ) : null}
                {["FINISHED", "PENDING"].includes(idTransactionStatus) ? (
                    <I18n
                        id={`${FORM_ID}.ticket.list.text `}
                        component="p"
                        componentProps={{ className: "font-ligth" }}
                    />
                ) : (
                    undefined
                )}
                {!isBackoffice && (
                    <div className="d-flex justify-content-center">
                        <Button
                            type="button"
                            bsStyle="outline"
                            block={false}
                            label={`${FORM_ID}.showList.button`}
                            className="px-5"
                            onClick={() => dispatch(multipleTransferActions.setShowDetail(true))}
                        />
                    </div>
                )}
                {idTransactionStatus === "PROCESSING" && !cmfApi ? (
                    <Hint
                        classNameMessage=""
                        classNameGroup="justify-content-center d-flex my-3"
                        classNameImage="my-0 ml-2 justify-content-center align-self-center"
                        classNameHintP="aling-items-center my-2"
                        alwaysShowMessage
                        nodeMessage={
                            <I18n
                                defaultValue={configUtils.get("frontend.MultipleTransfer.notice.message", null, {
                                    MAX_ALLOWED_TIME: configUtils.getInteger(
                                        "frontend.MultipleTransfer.max.allowed.time",
                                    ),
                                })}
                                component="p"
                                componentProps={{ className: "hint-text" }}
                            />
                        }
                    />
                ) : (
                    undefined
                )}
            </div>
            {!isBackoffice && (
                <MultipleTransferModal
                    isDesktop={isDesktop}
                    setShow={(show) => dispatch(multipleTransferActions.setShowDetail(show))}
                    list={itemsDetail}
                />
            )}
        </>
    );
}

MultipleTransferTicketData.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    data: shape({}).isRequired,
    batch: shape({}).isRequired,
    itemsDetail: arrayOf(),
    isBackoffice: bool,
    componentClass: string,
};

MultipleTransferTicketData.defaultProps = {
    itemsDetail: [],
    isBackoffice: false,
    componentClass: "",
};

const mapStateToProps = (state) => ({
    itemsDetail: selectorsTransactionLines.getTransactionLines(state),
});

export default connect(mapStateToProps)(MultipleTransferTicketData);
